import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

interface LeadModalState {
  isOpen: boolean;
  source: string;
  open: (source: string) => void;
  close: () => void;
}

const Ctx = createContext<LeadModalState | null>(null);

export function LeadModalProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState({ isOpen: false, source: 'unknown' });

  const open = useCallback((source: string) => {
    setState({ isOpen: true, source });
  }, []);

  const close = useCallback(() => {
    setState((s) => ({ ...s, isOpen: false }));
  }, []);

  const value = useMemo(
    () => ({ ...state, open, close }),
    [state, open, close]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useLeadModal() {
  const ctx = useContext(Ctx);
  if (!ctx)
    throw new Error('useLeadModal precisa estar dentro de LeadModalProvider');
  return ctx;
}
